import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails, OwnerRequestDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class AddOwnerCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IAddOwnerCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'carriers/{carrierId}/vehicleOwners';

  override setParameters(parameters: IAddOwnerCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId
    );
    this._commandBody = parameters;
  }
}
export interface IAddOwnerCommandParameters
  extends OwnerRequestDTO,
    ICommandParameters {}
